import {
  Space,
  Row,
  Col,
  Button,
  Table,
  Typography,
  Divider,
  Popover,
  message,
  Form,
} from "antd";
import React, {useEffect, useState} from "react";
import {InputFields} from "components/common";
import Icons from "assets/icons";
import {inputFields as inputFieldsInit, allColumns} from "./config";
import {ColumnProps} from "types/models";
import {
  // pharmacyStoreService,
  // inventoryMedicineStoreService,
  medicalSuppliesService,
} from "api";
import {FORMAT_TIME, LOAI_FORM, LOAI_PHIEU_VTYT, tabKeys} from "types/enums";
// import { setListStore } from "redux/reducer/pharmacyStore";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {
  getSuppliesNameAPI,
  getSuppliesStoreAPI,
} from "redux/reducer/medicalSupplies";
import Notification from "components/common/notification/notification";
import {renderSTT} from "helper/common";

const Report = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const khoVTYTQuanLy = JSON.parse(localStorage.getItem("khoVTYTQuanLyLocal"));
  // const listStore = useAppSelector((state) => state.pharmacyStore.listStore);
  const medicalSuppliesStore = useAppSelector(
    state => state.medicalSuppliesReducer
  );

  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [data, setData] = useState();
  const [columns, setColumns] = useState<ColumnProps[]>(
    allColumns.filter(e => e.show == true)
  );

  const [params, setParams] = useState<any>({
    page: 1,
    limit: 100,
    // storeName: khoVTYTQuanLy?.value || "",
  });
  const _renderSTT = (page, limit) => {
    allColumns.find(e => e.dataIndex == "index").render = (
      value,
      _record,
      index
    ) => {
      return <>{renderSTT(index, page, limit)}</>;
    };
  };

  useEffect(() => {
    if (khoVTYTQuanLy?.value === 0 || khoVTYTQuanLy?.value) {
      form.setFieldValue("storeId", khoVTYTQuanLy.value);
    }
  }, [khoVTYTQuanLy?.value]);

  useEffect(() => {
    dispatch(getSuppliesStoreAPI({}));
    // getListStore();
    dispatch(getSuppliesNameAPI());
  }, []);

  useEffect(() => {
    getListReport();
  }, [params]);
  useEffect(() => {
    setOptionsSearchFields(medicalSuppliesStore.suppliesStoreList, "storeId");
  }, [medicalSuppliesStore.suppliesStoreList]);
  useEffect(() => {
    setOptionsVTFields(medicalSuppliesStore.medicalSuppliesList);
  }, [medicalSuppliesStore.medicalSuppliesList]);
  const setOptionsSearchFields = (list, name) => {
    if (inputFieldsInit.find(field => field.name === name)) {
      inputFieldsInit.find(field => field.name === name).options = list?.map(
        item => ({
          value: item.id,
          label: item.name,
        })
      );
    }
  };
  const setOptionsVTFields = list => {
    if (inputFieldsInit.find(field => field.name === "VTYTName")) {
      inputFieldsInit.find(field => field.name === "VTYTName").options =
        list?.map(item => ({
          value: item.tenTheoThuongMai,
          label: item.tenTheoThuongMai,
        }));
    }
  };
  const onChangePagination = (page, pageSize) => {
    setParams({...params, page: page, limit: pageSize});
    _renderSTT(page, pageSize);
  };

  const getListReport = async () => {
    setLoading(true);
    try {
      const res = await medicalSuppliesService.getThongKeVatTu(params);
      setData(res.content);
      setTotal(res.totalElements);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi lấy danh sách thống kê mặt hàng");
    }
  };

  const onClickSearch = () => {
    const formValue = form.getFieldsValue();
    setParams({...params, ...formValue, page: 1});
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };

  return (
    <div className="medicine-container" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="container">
        <Form form={form}>
          <Row gutter={[16, 8]}>
            {inputFieldsInit && <InputFields data={inputFieldsInit} />}
          </Row>
          <Row justify={"end"} style={{marginTop: 12}}>
            <Space>
              <Button
                type="ghost"
                className="btn-sub"
                icon={<Icons.reload rev={0} />}
                onClick={() => {
                  form.resetFields();
                }}
              >
                Xoá tìm kiếm
              </Button>
              <Button
                icon={<Icons.search rev={0} />}
                type="primary"
                onClick={onClickSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Form>
      </div>
      <div className="container">
        <Space style={{width: "100%"}} direction="vertical">
          <Typography.Text strong>
            Danh sách tổng hợp số lượng mặt hàng
          </Typography.Text>
          <Divider type="horizontal" style={{margin: "0"}} />
          {/* <Row justify={"space-between"} gutter={[16, 8]}>
            <Col>
              <Button className="excel-button">
                <Space align="center">
                  <ExcelSVG className="excel-icon-svg" />
                  <Typography>Xuất báo cáo</Typography>
                </Space>
              </Button>
            </Col>
            <Col>
              <Space style={{width: "100%"}}>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={allColumns}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars rev={0} />}
                    className="btn-sub"
                    type="ghost"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>

                <Button
                  icon={<Icons.file rev={0} />}
                  className="btn-sub"
                  type="ghost"
                  onClick={() => {
                    createPhieu();
                  }}
                >
                  Tạo kiểm kê mới
                </Button>
                <Button
                  icon={<Icons.file rev={0} />}
                  className="btn-sub"
                  type="ghost"
                  onClick={() => {
                    viewDeTailPhieu();
                  }}
                >
                  Chi tiết phiếu
                </Button>
                <Button
                  icon={<Icons.file rev={0} />}
                  className="btn-sub"
                  type="ghost"
                >
                  In phiếu
                </Button>
              </Space>
            </Col>
          </Row> */}
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{
              position: ["bottomRight"],
              showSizeChanger: true,
              total: total,
              onChange: onChangePagination,
              pageSize: params?.limit,
            }}
            bordered={true}
          />
        </Space>
      </div>
    </div>
  );
};

export default Report;
